export function PoweredBy({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-2 text-[11px] text-muted-foreground ${className}`} data-testid="powered-by-home-smart">
      <span>Powered by</span>
      <img src="/home-smart-logo.png" alt="Home Smart" className="h-5 w-5 rounded-full object-contain bg-white border border-border" />
      <span className="font-semibold text-foreground">Home Smart</span>
    </div>
  );
}
